// extracted by mini-css-extract-plugin
export default {"custom-report":"CustomReportsModalBody_custom-report__deAaA","custom-report__field":"CustomReportsModalBody_custom-report__field__7yGP0"};